const StudentDetails = () => {
    return (
        <div id="student" className="vision-card">
            <h3>STUDENT DETAILS</h3>

            <div className="table-section-wrap">
                <table className="table-section">
                    <thead>
                        <tr>
                            <th>CLASS</th>
                            <th>TOTAL NUMBER OF STUDENTS</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr><td>NURSERY</td><td>26</td></tr>
                        <tr><td>LKG</td><td>35</td></tr>
                        <tr><td>UKG</td><td>59</td></tr>
                        <tr><td>I</td><td>80</td></tr>
                        <tr><td>II</td><td>80</td></tr>
                        <tr><td>III</td><td>80</td></tr>
                        <tr><td>IV</td><td>120</td></tr>
                        <tr><td>V</td><td>120</td></tr>
                        <tr><td>VI</td><td>120</td></tr>
                        <tr><td>VII</td><td>120</td></tr>
                        <tr><td>VIII</td><td>160</td></tr>
                        <tr><td>IX</td><td>253</td></tr>
                        <tr><td>X</td><td>249</td></tr>
                        <tr><td>XI</td><td>164</td></tr>
                        <tr><td>XII</td><td>172</td></tr>
                    </tbody>
                </table>
            </div>
        </div>

    );
};

export default StudentDetails;